import {
  DEFAULT_LISTING_SURFACES,
  type ListingSurfaceConfig,
  type ListingSurfaceKey,
} from '../constants/listingSurfaces';

export function mergeListingSurfaces(overrides: ListingSurfaceConfig[] | undefined): ListingSurfaceConfig[] {
  const byKey = new Map<ListingSurfaceKey, ListingSurfaceConfig>();
  for (const base of DEFAULT_LISTING_SURFACES) byKey.set(base.surfaceKey, { ...base });
  for (const row of overrides ?? []) {
    if (row?.surfaceKey && byKey.has(row.surfaceKey)) {
      byKey.set(row.surfaceKey, { ...byKey.get(row.surfaceKey)!, ...row, surfaceKey: row.surfaceKey });
    }
  }
  return [...byKey.values()];
}

export function getListingSurface(
  key: ListingSurfaceKey,
  surfaces: ListingSurfaceConfig[] = DEFAULT_LISTING_SURFACES,
): ListingSurfaceConfig {
  return surfaces.find((s) => s.surfaceKey === key) ?? DEFAULT_LISTING_SURFACES.find((s) => s.surfaceKey === key)!;
}
